module.exports = {"530623101":"盐井镇","530623102":"普洱镇","530623103":"豆沙镇","530623104":"中和镇","530623105":"庙坝镇","530623106":"柿子镇","530623201":"兴隆乡","530623202":"落雁乡","530623203":"滩头乡","530623204":"牛寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530623.json
// module id = 2717
// module chunks = 0